import { Stack } from '@mui/material';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';

import { PageStyle } from '../../../../assets/styles/custom.styles';
import getErrorMessage from '../../../../assets/utils/getErrorMessage';
import CustomerUserList from '../../../../components/partner/customer/customerUserList';

export interface TenantUserObject {
  id: string;
  fullName: string;
  departmentName: Array<string>;
  lastActive: string;
  status: string;
}

interface TenantUserFromApiObject {
  id: string;
  full_name: string,
  department_name: string[],
  last_active: string,
  status: string,
}

const transformTenantUserData = (data: TenantUserFromApiObject[]) => {
  const tenants: TenantUserObject[] = data.map(({ id, full_name, department_name, last_active, status }) => ({
    id,
    status,
    fullName: full_name, 
    departmentName: department_name, 
    lastActive: last_active,
  }
  ));
  return tenants;
};


const CustomerUserListPage = () => {
  const { slug } = useParams();
  const [userList, setUserList] = useState<Array<TenantUserObject>>([]);

  const { data, isLoading, error } = useSWR(slug ? `/confide/tenants/${slug}/users` : '', { revalidateOnFocus: false });

  useEffect(() => {
    if (!isLoading && !error) {
      const transformedData = transformTenantUserData(data);
      setUserList(transformedData);
    }
  }, [data, isLoading, error]);

  return (
    <Stack sx={PageStyle.container}>
      <CustomerUserList 
        isLoading={isLoading}
        isError={error}
        errorText={getErrorMessage(error)}
        list={userList}
      />
    </Stack>
  );
};

export default CustomerUserListPage;